<template>
    <div>
        <apexcharts width="100%"
            height="280"
            type="pie"
            :options="options"
            :series="series"
            v-if="!loading"></apexcharts>
    </div>
</template>

<script>
import _ from 'lodash'
import productsService from '@/components/products/services'
import VueApexCharts from 'vue-apexcharts'

export default {
    name: 'StatisticsProducts',

    components: {
        apexcharts: VueApexCharts
    },

    data () {
        return {
            options: {
                labels: ['Activos', 'Inactivos'],
                colors: ['#70a1ff', '#b9b9b9']
            },

            series: [],

            loading: false
        }
    },

    methods: {
        async fetchProducts (activeState) {
            let parameters = {
                pagination: {
                },
                orderBy: {
                },
                filter: {
                    active: activeState
                }
            }

            let response = await productsService.retrieve(parameters)
            return response.data.pagination.totalItems
        },

        async generateValues () {
            let self = this
            self.loading = true
            let productsValues = []

            let activeProducts = await this.fetchProducts(1)
            productsValues.push(activeProducts)

            let inactiveProducts = await this.fetchProducts(0)
            productsValues.push(inactiveProducts)

            self.series = _.cloneDeep(productsValues)
            self.loading = false
        }
    },

    async mounted () {
        await this.generateValues()
    }
}
</script>
